import Reveal from "@/components/feature/Reveal";

const pillars = [
  {
    icon: "ri-pencil-ruler-2-line",
    title: "DISEÑO",
    text: "Arquitectura moderna, funcional y pensada para las necesidades actuales.",
  },
  {
    icon: "ri-award-line",
    title: "CALIDAD",
    text: "Compromiso con altos estándares de construcción y terminaciones.",
  },
  {
    icon: "ri-shield-check-line",
    title: "CONFIANZA",
    text: "Proyectos desarrollados pensando en seguridad, tranquilidad y valorización a largo plazo.",
  },
];

export default function Vision() {
  return (
    <section className="px-4 md:px-8 lg:px-12 py-20 md:py-28 bg-background-100/70">
      <div className="max-w-7xl mx-auto flex flex-col items-center gap-12">
        <Reveal className="flex flex-col items-center gap-4 text-center">
          <span className="text-xs md:text-sm font-semibold uppercase tracking-[0.25em] text-primary-600">
            Nuestra visión
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl leading-tight text-foreground-900 max-w-3xl">
            Espacios donde las personas construyen su futuro
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full">
          {pillars.map((pillar, index) => (
            <Reveal key={pillar.title} delay={index * 120}>
              <div className="flex flex-col gap-4 rounded-lg border border-background-200/70 bg-background-50 p-8 h-full hover:-translate-y-1.5 transition-transform duration-500">
                <span className="w-14 h-14 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className={`${pillar.icon} text-2xl`} />
                </span>
                <h3 className="font-heading text-2xl text-foreground-900 tracking-wide">
                  {pillar.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{pillar.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <blockquote className="max-w-3xl text-center">
            <p className="font-heading text-2xl md:text-3xl italic text-foreground-800 leading-snug">
              &ldquo;Creamos proyectos pensados para vivir hoy y valorizarse mañana.&rdquo;
            </p>
          </blockquote>
        </Reveal>
      </div>
    </section>
  );
}